<template>
    <div id="step-kind" class="step" :class="this.$parent.edit ? 'disabled' : ''">
        <div class="step-header d-none d-md-block">
            <div class="svg-icon"
                 :style="'mask: url(/img/icons/key.svg); -webkit-mask-image: url(/img/icons/key.svg);'"></div>
            {{ $t('titles.sale_lease') }} *
            <i v-if="this.$parent.edit">Pro změnu tohoto parametru vytvořte nový odhad</i>
        </div>

            <div v-if="showSelect">
                <div class="form-group w-100">
                    <label for="lease_or_rent" class="required font-weight-medium d-md-none">
                        {{ $t('titles.sale_lease') }}
                    </label>
                    <select class="custom-select border-radius-20 " id="kind" name="kind"
                            @change="setKind($event.target.value)"
                    >
                        <option
                            value="sale"
                        >
                            {{ $t('kind.sale') }}
                        </option>
                        <option
                            v-if="type !== 'land'"
                            value="lease"
                        >
                            {{ $t('kind.lease') }}
                        </option>
                    </select>
                </div>
            </div>
            <div v-else>
                <div class="row">
                    <div class="col-12 col-md-6 mb-2 mb-sm-0">
                        <div id="sale" class="radio-check m-0 text" v-on:click="setKind('sale')">
                            <div class="card card-border shadow-none">
                                <div class="card-body">
                                    <div class="row">
                                        <div class="col-12 col-xl-8">
                                            <h6>{{ $t('kind.sale') }}</h6>
                                            <p class="mb-2">{{ $t('kind.help.sale') }}</p>
                                        </div>
                                        <div class="col-12 col-xl-4 d-flex align-items-center justify-content-center">
                                            <span class="btn btn-outline-secondary" v-if="kind !== 'sale'">{{ $t('buttons.choose') }}</span>
                                            <span class="btn btn-primary" v-else><i class="fas fa-check"></i>&nbsp;{{ $t('buttons.chosen') }}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <input type="radio" name="kind" value="sale" required>
                        </div>
                    </div>

                    <div class="col-12 col-md-6">
                        <div id="lease" class="radio-check m-0 text disabled" v-if="type === 'land'">
                            <div class="card card-border shadow-none">
                                <div class="card-body">
                                    <div class="row">
                                        <div class="col-12 col-xl-8">
                                            <h6>{{ $t('kind.lease') }}</h6>
                                            <p class="mb-2">{{ $t('kind.help.lease') }}</p>
                                        </div>
                                        <div class="col-12 col-xl-4 d-flex align-items-center justify-content-center">
                                            <span class="btn rounded-white-btn">{{ $t('buttons.choose') }}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <input type="radio" name="kind" value="lease" required disabled>
                        </div>
                        <div id="lease" class="radio-check m-0 text" v-on:click="setKind('lease')" v-if="type !== 'land'">
                            <div class="card card-border shadow-none">
                                <div class="card-body">
                                    <div class="row">
                                        <div class="col-12 col-xl-8">
                                            <h6>{{ $t('kind.lease') }}</h6>
                                            <p class="mb-2">{{ $t('kind.help.lease') }}</p>
                                        </div>
                                        <div class="col-12 col-xl-4 d-flex align-items-center justify-content-center">
                                            <span class="btn btn-outline-secondary" v-if="kind !== 'lease'">{{ $t('buttons.choose') }}</span>
                                            <span class="btn btn-primary" v-else><i
                                                class="fas fa-check"></i>&nbsp;{{ $t('buttons.chosen') }}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <input type="radio" name="kind" value="lease" required>
                        </div>
                    </div>
                </div>
            </div>
    </div>
</template>

<script>
export default {
    name: "Calculation",

    data: function () {
        return {
            kind: null,
            showSelect: false,
        }
    },

    mounted: function () {
        if (!this.$parent.edit) {
            $('#step-kind .radio-check').on('click', function () {
                if (!$(this).hasClass('disabled')) {
                    $('#step-kind .radio-check').removeClass('active');
                    $(this).addClass('active');
                    $(this).find('input').prop('checked', true);
                }
            });
        }

        let kind = 'sale';
        this.setKind(kind, true);
        if (this.$parent.oldData.kind) {
            this.setKind(this.$parent.oldData.kind, true);
            kind = this.$parent.oldData.kind;
        }
        $('#step-kind .radio-check input[value="' + kind + '"]').prop('checked', true);

        this.showSelectToMaxWidth(1200);
    },

    computed: {
        required: function () {
            return this.kind != null;
        },

        type: function () {
            let type = this.$parent.getType();
            if (type == "cottage" || type == "hut") {
                type = "house";
            }

            if (type == "land") {
                this.setKind('sale');
                $('#step-kind .radio-check input[value="sale"]').prop('checked', true);
            }

            return type;
        },
    },

    methods: {
        setKind: function (kind, force = false) {
            if (!this.$parent.edit || force) {
                $('#step-kind .radio-check').removeClass('active');
                $('#' + kind).addClass('active');
                this.kind = kind;
            }
        },
    }
}
</script>

<style scoped>
input[type="radio"] {
    display: none;
}

.radio-check {
    cursor: pointer;
}

.radio-check.disabled .image, .radio-check.disabled .btn {
    cursor: not-allowed;
    background-color: lightgray;
    border-color: gray;
}
</style>
